// extracted by mini-css-extract-plugin
module.exports = {"all":"Paginated_all__3z096","listaPag":"Paginated_listaPag__288d_","active":"Paginated_active__1OcJ0","previous":"Paginated_previous__XmClx","next":"Paginated_next__2LjP6"};